import React, { useEffect, useState } from 'react'
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Grid,
  Stack,
  Typography,
} from '@mui/material'
import {
  ArchiveRounded,
  DirectionsCarRounded,
  RestoreRounded,
} from '@mui/icons-material'
import API from '../../../../services/API'
import AmbulanceIcon from '../../../../assets/icons/Ambulance'

export default function ArchivedVehicles() {
  const [loading, setLoading] = useState(true)
  const [vehicles, setVehicles] = useState([])
  const [processingId, setProcessingId] = useState(null)

  const loadVehicles = async () => {
    setLoading(true)
    API.get('/vehicles/archived')
      .then((res) => {
        if (res.status === 200) {
          console.log('rdRD', res.data)
          setVehicles(res.data)
        }
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    loadVehicles()
  }, [])

  const handleUnarchive = async (vehicleId) => {
    setProcessingId(vehicleId)
    await API.put(`/vehicles/unarchive/${vehicleId}`)
      .then((res) => {
        if (res.status === 200) {
          setVehicles((prev) => prev.filter((v) => v._id !== vehicleId))
        }
      })
      .catch((e) => console.error(e))
      .finally(setProcessingId(null))
  }

  return (
    <Box>
      <Stack spacing={1.5}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            color: '#374151',
            borderLeft: '4px solid #3b82f6',
            pl: 1.5,
          }}
        >
          Archived Vehicles
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
          Review archived vehicles and restore them if they are returning to
          service.
        </Typography>
        {loading && (
          <Stack alignItems="center" py={4}>
            <CircularProgress />
          </Stack>
        )}

        {!loading && vehicles.length === 0 && (
          <Alert severity="success" sx={{ borderRadius: 1 }}>
            There are no archived vehicles.
          </Alert>
        )}

        <Grid container spacing={2}>
          {vehicles.map((vehicle) => (
            <Grid item xs={12} md={6} lg={4} key={vehicle._id}>
              <Card
                elevation={0}
                sx={{
                  height: '100%',
                  borderRadius: 3,
                  border: '1px solid rgba(15,23,42,0.08)',
                  boxShadow: '0 8px 28px rgba(15,23,42,0.06)',
                }}
              >
                <CardContent>
                  <Stack spacing={2}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Typography variant="title3" flex={1}>
                        {vehicle.callSign}
                      </Typography>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        //   width="100%"
                        padding={0}
                        borderRadius={1}
                        sx={{ backgroundColor: '#FFD307' }}
                      >
                        <Typography
                          fontFamily="UKnumberplate"
                          fontSize={24}
                          padding={1}
                        >
                          {vehicle.regPlate}
                        </Typography>
                      </Box>
                    </Stack>

                    <Stack spacing={0.5}>
                      <Typography variant="body2" color="text.secondary">
                        Base location
                      </Typography>
                      <Typography fontWeight={600}>
                        {vehicle.baseLocation?.name || 'Not recorded'}
                      </Typography>
                    </Stack>

                    <Button
                      fullWidth
                      variant="contained"
                      startIcon={<RestoreRounded />}
                      disabled={processingId === vehicle._id}
                      onClick={() => handleUnarchive(vehicle._id)}
                      sx={{
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 800,
                      }}
                    >
                      {processingId === vehicle._id
                        ? 'Restoring...'
                        : 'Unarchive vehicle'}
                    </Button>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Box>
  )
}
